import styled, { css } from 'styled-components'
import { fontSize } from '../../../../DashboardSettings.styles'
import { colors, fonts } from 'modules/dashboard/Home/Dashboard.global.styles'

import Button from 'components/UI/Button/Button'
import Select from 'components/UI/FormInput/SettingsSelect'

export const Wrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
`

export const StyledSelect = styled(Select)`
  margin-right: 20px;
`

export const StyledButton = styled(Button)`
  margin-top: 4px;
`

export const ClassroomIcon = styled.div`
  background-image: url('${ASSETS_PATH}/icons/classroom.png');
  background-size: cover;
  background-position: center;
  height: 31px;
  width: 31px;
`
